// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.atRw4P {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100%;
  gap: var(--spacing-3);
}

.Ek5Y1C,
.YeGvBE {
  background: var(--surface-neutral-white);
  border-radius: var(--radius-s);
  box-shadow: 0px 2px 4px 0px #0000001f;
}

.Ek5Y1C {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
}

.qXVerA {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--spacing-2);
}

.qXVerA h1 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--color-text-primary);
}

.h_W_uP {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 400px;
  padding: var(--spacing-4);
}

.P9xGFf {
  background: rgba(214, 64, 0, 0.1);
  border-radius: 50%;
  display: flex;
  height: 72px;
  width: 72px;
  align-items: center;
  justify-content: center;
}

.fSXk6A {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  margin-bottom: var(--spacing-1);
  margin-top: var(--spacing-3);
}

.b7D9L3 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  margin-bottom: 0;
  text-align: center;
}

@media (max-width: 768px) {
  .atRw4P {
    padding: var(--spacing-2);
  }

  .qXVerA {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-2);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/CardTrackingPage/CardTrackingPage.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,wCAAwC;EACxC,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;EACvB;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 100%;\n  gap: var(--spacing-3);\n}\n\n.content,\n.footer {\n  background: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n  box-shadow: 0px 2px 4px 0px #0000001f;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: var(--spacing-2);\n}\n\n.header h1 {\n  margin: 0;\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.feedbackContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  min-height: 400px;\n  padding: var(--spacing-4);\n}\n\n.feedbackIconContent {\n  background: rgba(214, 64, 0, 0.1);\n  border-radius: 50%;\n  display: flex;\n  height: 72px;\n  width: 72px;\n  align-items: center;\n  justify-content: center;\n}\n\n.feedbackTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  margin-bottom: var(--spacing-1);\n  margin-top: var(--spacing-3);\n}\n\n.feedbackText {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  margin-bottom: 0;\n  text-align: center;\n}\n\n@media (max-width: 768px) {\n  .container {\n    padding: var(--spacing-2);\n  }\n\n  .header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--spacing-2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `atRw4P`,
	"content": `Ek5Y1C`,
	"footer": `YeGvBE`,
	"header": `qXVerA`,
	"feedbackContainer": `h_W_uP`,
	"feedbackIconContent": `P9xGFf`,
	"feedbackTitle": `fSXk6A`,
	"feedbackText": `b7D9L3`
};
module.exports = ___CSS_LOADER_EXPORT___;
